import he from 'he';
import numeral from 'numeral';

export const escapeUriPath = (value: unknown, spaceReplacementChar?: string) => {
  let valueString = `${value}`;
  valueString = valueString
    .trim()
    .replace(/[^\w\s]/gi, '')
    .replace(/ +/g, spaceReplacementChar ? spaceReplacementChar : '-');
  return valueString;
};

export const changeAmazonImageUrlResolution = (imageUrl: string, resolution: number): string => {
  const reg = /_SL\d+/;
  return imageUrl.includes('media-amazon.com') && imageUrl.includes('_SL')
    ? imageUrl.replace(reg, `_SL${resolution}`)
    : imageUrl;
};

export const isParentProduct = (stacklineSku: string) => {
  const regex = new RegExp('^(?:[0-9]_{1}:?){1}');
  return regex.test(stacklineSku);
};

export const removeTrailingSlash = (str: string): string => {
  return str.endsWith('/') ? str.slice(0, -1) : str;
};

export const getRetailerFromId = (retailerId: number) => {
  const retailers: Record<number, string> = {
    1: 'Amazon',
    2: 'Walmart',
    3: 'Best Buy',
    4: 'Target',
    6: 'Home Depot',
    9: 'Costco',
    18: 'Chewy',
    48: 'Kroger',
    50: 'Sephora',
    92: 'Safeway',
    94: 'Albertsons',
    127: 'Fred Meyer',
    128: 'Ralphs',
    129: 'Kroger',
    116: 'PetSmart',
  };

  return retailers[retailerId] || `${retailerId}`;
};

export const hexadecimal = (color: string) => {
  return (percentage: number): string => {
    const decimal = `0${Math.round(255 * (percentage / 100)).toString(16)}`.slice(-2).toUpperCase();
    return color + decimal;
  };
};

export const roundFloat = (value: number | string, decimals = 4) => {
  return value ? parseFloat(Number(value).toFixed(decimals)) : 0;
};

export const formatMoney = (num: number, currencySymbol = '$', includeDecimal = true) => {
  return numeral(roundFloat(num)).format(`${currencySymbol}0,0${includeDecimal ? `.00` : ``}`);
};

/**
 * Decode a string of HTML text
 *
 * This function takes a string of HTML and decodes any named
 * and numerical character references
 **/
export const decodeHTMLCharacters = (str: string) => he.decode(str);
